import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {css} from "@emotion/react";

import {p} from "@pg-design/helpers-css-strings";
import {Loader} from "@pg-design/loader-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {fromQueryValues, toQueryValues} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {usePropertyList} from "../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../property_list/PropertyListFilters";
import {PropertyListType} from "../../../property_list/PropertyListTabSwitcher";
import {closeQuickViewHit, openQuickViewHit} from "../../../tracking/algolytics_hits/map_quick_view_sidebar_hit";
import {ILatestQuery} from "../../../utils/latest_query";
import {useGetOfferDetailMapQuery} from "../../api/get_offer_detail";
import {OfferSidebar} from "../../atoms/OfferSidebar";
import {OfferSidebarBox} from "../../atoms/OfferSidebarBox";
import {OfferSidebarPropertiesList} from "../../atoms/OfferSidebarPropertiesList";
import {fetchOfferDetailProperties, PropertyListTabTypes} from "../../detail/actions/fetch_offer_detail_properties";
import {propertyListTableFiltersFields} from "../../detail/components/property_list/OfferDetailPropertyListTable";
import {IUseMapOfferListQueryResult} from "../../hooks/use_map_offer_list_query";
import {DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE} from "../../list/components/OfferListPropertiesModal";
import {ExpandablePanel} from "../os_map_for_offers/atoms/ExpandablePanel";
import {MapOfferExpandablePanelOffer} from "./MapOfferExpandablePanelOffer";
import {MapOfferExpandablePanelQuickView} from "./MapOfferExpandablePanelQuickView";

interface IProps {
    offerId: number;
    onClose: () => void;
    latestQuery: ILatestQuery;
    mapOfferListQuery?: IUseMapOfferListQueryResult;
    isOpen: boolean;
    handleSetOfferId: (offerId: number | null) => void;
}

export const MapOfferPreview = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useDispatch();
    const {data: offer} = useGetOfferDetailMapQuery(props.offerId);
    const latestSearchFilters = fromQueryValues<ISearchFiltersFormValues>(propertyListTableFiltersFields, props.latestQuery);
    const searchFiltersToQuery = toQueryValues(propertyListTableFiltersFields, latestSearchFilters);

    const propertyList = usePropertyList(props.offerId, PropertyListTabTypes.MODAL, undefined, DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE, searchFiltersToQuery);
    const {requestState} = propertyList;

    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const [currentPropertyListType, setCurrentPropertyListType] = useState<PropertyListType>(PropertyListType.TILES);

    const handleQuickViewOpen = (id: number) => {
        setSelectedIndex(id);
        openQuickViewHit(props.offerId, propertyList.properties[id].id);
    };

    const handleQuickViewClose = (): void => {
        setSelectedIndex(null);
        closeQuickViewHit();
    };

    useEffect(() => {
        if (offer && props.isOpen) {
            fetchOfferDetailProperties(
                props.offerId,
                PropertyListTabTypes.MODAL,
                DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE,
                {page: 1, ...(propertyList.sort.currentSort ? {sort: propertyList.sort.currentSort} : {})},
                searchFiltersToQuery
            )(dispatch);
            propertyList.page.setCurrentPage(1);
        }
    }, [offer, props.isOpen]);

    return (
        <>
            {!isMobile && (
                <OfferSidebar animation={props.isOpen} css={mapOfferSidebarStyle}>
                    {props.isOpen && offer && (
                        <React.Suspense fallback={<Loader />}>
                            <div css={sidebarContentWrapperStyle}>
                                <OfferSidebarBox offer={offer} onOfferSidebarClose={props.onClose} />
                                <OfferSidebarPropertiesList
                                    offer={offer}
                                    latestQuery={props.latestQuery}
                                    propertyList={propertyList}
                                    propertyListType={currentPropertyListType}
                                    gtmMeta={gtmMeta}
                                    onPropertyListTypeClick={setCurrentPropertyListType}
                                />
                            </div>
                        </React.Suspense>
                    )}
                </OfferSidebar>
            )}
            {isMobile && offer && (
                <ExpandablePanel handleClose={props.onClose} isOpen={props.isOpen} css={panelStyle}>
                    <React.Suspense fallback={<Loader />}>
                        {selectedIndex === null && (
                            <MapOfferExpandablePanelOffer
                                offer={offer}
                                handleSetOfferId={props.handleSetOfferId}
                                latestQuery={props.latestQuery}
                                mapOfferListQuery={props.mapOfferListQuery}
                                handleQuickViewOpen={handleQuickViewOpen}
                                propertyListType={currentPropertyListType}
                                onPropertyListTypeClick={setCurrentPropertyListType}
                            />
                        )}
                        {selectedIndex !== null && (
                            <MapOfferExpandablePanelQuickView
                                handleQuickViewClose={handleQuickViewClose}
                                propertyList={propertyList}
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                propertiesRequestState={requestState}
                                offer={offer}
                            />
                        )}
                    </React.Suspense>
                </ExpandablePanel>
            )}
        </>
    );
};

const gtmMeta = {
    listId: "zobacz_na_mapie",
    listName: "Zobacz na mapie"
};

const panelStyle = css`
    width: 100%;
    ${p(0)};
`;

const mapOfferSidebarStyle = css`
    @media (min-width: ${getThemeBreakpoint().md}) {
        padding: 0;
        width: max(70rem, 42%);
    }
`;

const sidebarContentWrapperStyle = css`
    display: flex;
    flex-direction: column;
    position: relative;
    ${p(1.5)};
    min-height: 100%;
`;
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {css} from "@emotion/react";

import {p} from "@pg-design/helpers-css-strings";
import {Loader} from "@pg-design/loader-module";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {fromQueryValues, toQueryValues} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {usePropertyList} from "../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../property_list/PropertyListFilters";
import {PropertyListType} from "../../../property_list/PropertyListTabSwitcher";
import {closeQuickViewHit, openQuickViewHit} from "../../../tracking/algolytics_hits/map_quick_view_sidebar_hit";
import {ILatestQuery} from "../../../utils/latest_query";
import {useGetOfferDetailMapQuery} from "../../api/get_offer_detail";
import {OfferSidebar} from "../../atoms/OfferSidebar";
import {OfferSidebarBox} from "../../atoms/OfferSidebarBox";
import {OfferSidebarPropertiesList} from "../../atoms/OfferSidebarPropertiesList";
import {fetchOfferDetailProperties, PropertyListTabTypes} from "../../detail/actions/fetch_offer_detail_properties";
import {propertyListTableFiltersFields} from "../../detail/components/property_list/OfferDetailPropertyListTable";
import {IUseMapOfferListQueryResult} from "../../hooks/use_map_offer_list_query";
import {DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE} from "../../list/components/OfferListPropertiesModal";
import {ExpandablePanel} from "../os_map_for_offers/atoms/ExpandablePanel";
import {MapOfferExpandablePanelOffer} from "./MapOfferExpandablePanelOffer";
import {MapOfferExpandablePanelQuickView} from "./MapOfferExpandablePanelQuickView";

interface IProps {
    offerId: number;
    onClose: () => void;
    latestQuery: ILatestQuery;
    mapOfferListQuery?: IUseMapOfferListQueryResult;
    isOpen: boolean;
    handleSetOfferId: (offerId: number | null) => void;
}

export const MapOfferPreview = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useDispatch();
    const {data: offer} = useGetOfferDetailMapQuery(props.offerId);
    const latestSearchFilters = fromQueryValues<ISearchFiltersFormValues>(propertyListTableFiltersFields, props.latestQuery);
    const searchFiltersToQuery = toQueryValues(propertyListTableFiltersFields, latestSearchFilters);

    const propertyList = usePropertyList(props.offerId, PropertyListTabTypes.MODAL, undefined, DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE, searchFiltersToQuery);
    const {requestState} = propertyList;

    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const [currentPropertyListType, setCurrentPropertyListType] = useState<PropertyListType>(PropertyListType.TILES);

    const handleQuickViewOpen = (id: number) => {
        setSelectedIndex(id);
        openQuickViewHit(props.offerId, propertyList.properties[id].id);
    };

    const handleQuickViewClose = (): void => {
        setSelectedIndex(null);
        closeQuickViewHit();
    };

    useEffect(() => {
        if (offer && props.isOpen) {
            fetchOfferDetailProperties(
                props.offerId,
                PropertyListTabTypes.MODAL,
                DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE,
                {page: 1, ...(propertyList.sort.currentSort ? {sort: propertyList.sort.currentSort} : {})},
                searchFiltersToQuery
            )(dispatch);
            propertyList.page.setCurrentPage(1);
        }
    }, [offer, props.isOpen]);

    return (
        <>
            {!isMobile && (
                <OfferSidebar animation={props.isOpen} css={mapOfferSidebarStyle}>
                    {props.isOpen && offer && (
                        <React.Suspense fallback={<Loader />}>
                            <div css={sidebarContentWrapperStyle}>
                                <OfferSidebarBox offer={offer} onOfferSidebarClose={props.onClose} />
                                <OfferSidebarPropertiesList
                                    offer={offer}
                                    latestQuery={props.latestQuery}
                                    propertyList={propertyList}
                                    propertyListType={currentPropertyListType}
                                    gtmMeta={gtmMeta}
                                    onPropertyListTypeClick={setCurrentPropertyListType}
                                />
                            </div>
                        </React.Suspense>
                    )}
                </OfferSidebar>
            )}
            {isMobile && offer && (
                <ExpandablePanel handleClose={props.onClose} isOpen={props.isOpen} css={panelStyle}>
                    <React.Suspense fallback={<Loader />}>
                        {selectedIndex === null && (
                            <MapOfferExpandablePanelOffer
                                offer={offer}
                                handleSetOfferId={props.handleSetOfferId}
                                latestQuery={props.latestQuery}
                                mapOfferListQuery={props.mapOfferListQuery}
                                handleQuickViewOpen={handleQuickViewOpen}
                                propertyListType={currentPropertyListType}
                                onPropertyListTypeClick={setCurrentPropertyListType}
                            />
                        )}
                        {selectedIndex !== null && (
                            <MapOfferExpandablePanelQuickView
                                handleQuickViewClose={handleQuickViewClose}
                                propertyList={propertyList}
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                propertiesRequestState={requestState}
                                offer={offer}
                            />
                        )}
                    </React.Suspense>
                </ExpandablePanel>
            )}
        </>
    );
};

const gtmMeta = {
    listId: "zobacz_na_mapie",
    listName: "Zobacz na mapie"
};

const panelStyle = css`
    width: 100%;
    ${p(0)};
`;

const mapOfferSidebarStyle = css`
    @media (min-width: ${getThemeBreakpoint().md}) {
        padding: 0;
        width: max(70rem, 42%);
    }
`;

const sidebarContentWrapperStyle = css`
    display: flex;
    flex-direction: column;
    position: relative;
    ${p(1.5)};
    min-height: 100%;
`;
